import { useState } from "react";
import XAxisTrend from "../../../../../Common/js/components/Chart/XAxisTrend.jsx";
import * as R from "ramda";
import parseISO from "date-fns/fp/parseISO";
import Popup from "../../../../../Common/js/components/Popup/Popup.jsx";
import { scrollToId } from "../../../common/scrollHelpers.js";

import { arrayOf, func, number } from "prop-types";
import { eventId, eventShape } from "../event.js";

const propTypes = {
  events: arrayOf(eventShape),
  marginLeft: number.isRequired,
  width: number,
  xScale: func.isRequired,
};

const MilestoneTimelineChart = (props) => {
  const { events, marginLeft, xScale } = props;

  const [hoveredEvent, setHoveredEvent] = useState();

  const svgWidth = props.width;
  const svgHeight = 160;

  const margin = {
    top: 0,
    right: 0,
    bottom: 40,
    left: marginLeft,
  };

  const height = svgHeight - margin.top - margin.bottom;

  const DOT_RADIUS = 4;

  const eventsWithPositions = R.compose(
    R.unnest,
    // precalculate the y position, so we can use it for both the
    // dots and the popups
    R.map((group) => {
      // stack the dots, so keep track of how many we've stacked
      let yIndex = 1;

      return group.map((event) => {
        const x = xScale(parseISO(event.year));
        const y = height - DOT_RADIUS * 4 * (event.isVisible ? yIndex++ : 0);
        return { ...event, x, y };
      });
    }),
    R.values,
    R.groupBy(R.prop("year")),
  )(events);

  return (
    <div className="milestone-timeline-chart">
      <div className="milestone-timeline-chart__popups">
        {eventsWithPositions.map((event) => {
          return (
            event.title && (
              <Popup
                key={eventId(event)}
                top={event.y}
                left={event.x + marginLeft}
                offset={10}
                isHidden={hoveredEvent !== eventId(event)}
                nudgeToContain=".milestone-timeline-chart__popups"
                style={{
                  "--popup-background-color": event.color,
                  "--popup-foreground-color": "white",
                }}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: event.title }}
                  style={{ maxWidth: 300 }}
                />
              </Popup>
            )
          );
        })}
      </div>
      <svg width={svgWidth} height={svgHeight}>
        <XAxisTrend
          className="milestone-timeline-chart__x-axis"
          height={height}
          margin={margin}
          scale={xScale}
        />
        <g
          className="milestone-timeline-chart__chart-area"
          transform={`translate(${margin.left}, ${margin.top})`}
        >
          {eventsWithPositions.map((event) => {
            const scale = hoveredEvent === eventId(event) ? 1.2 : 1;

            return (
              <g
                key={eventId(event)}
                transform={`translate(${event.x} ${event.y})`} // for IE
                style={{
                  transform: `translate(${event.x}px, ${event.y}px)`,
                  transition: "all 250ms",
                  opacity: event.isVisible ? 1 : 0,
                  pointerEvents: event.isVisible ? "auto" : "none",
                }}
              >
                <circle
                  className="milestone-timeline-chart__event-hit-area"
                  r={DOT_RADIUS * 2}
                  fill="transparent"
                  onMouseEnter={(e) => setHoveredEvent(eventId(event))}
                  onMouseLeave={(e) => setHoveredEvent()}
                  onClick={(e) => scrollToId(eventId(event))}
                  style={{ cursor: "pointer" }}
                />
                <circle
                  className="milestone-timeline-chart__event"
                  r={DOT_RADIUS}
                  fill={event.color}
                  transform={`scale(${scale})`}
                  style={{ pointerEvents: "none" }}
                />
              </g>
            );
          })}
        </g>
      </svg>
    </div>
  );
};

MilestoneTimelineChart.propTypes = propTypes;
export default MilestoneTimelineChart;
